import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { BiltyConsignorConsigneeCss as useStyles } from '../BiltyCss';
import {
    IconButton,
    Switch,
    Grid,
    Button,
    FormHelperText,
    InputAdornment
} from '@material-ui/core';
import * as logger from '../../../../logger';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import AddIcon from '@material-ui/icons/Add';
import ConsigneeConsignorSelect from '../../../components/BiltyDialogs/ConsigneeConsignorSelect';
import DateFnsUtils from '@date-io/date-fns';
import { biltyDataPopulated, biltyContinueClick } from '../../../../store/actions/tripActionCreator';
import TextInputState from '../../../components/Inputs/TextInputState';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';


export const BiltyConsignorConsignee = ({ trip,selectedTrip,selectedLr,journey,updateJourney, dispatchBiltyDataPopulated, open, dispatchBiltyContinueClick, onDataPopulated }) => {

    let submit;

    const classes = useStyles();

    const [selectionDialog, setSelectionDialog] = useState(false);
    const [type, setType] = useState("");
    const [consigneeData, setConsigneeData] = useState({});
    const [consignorData, setConsignorData] = useState({});
    const [populatedConsignee, setPopulatedConsignee] = useState("");
    const [populatedConsignor, setPopulatedConsignor] = useState("");
    const [lrDateValue, setLrDateValue] = useState("");
    const [lrNumber, setLrNumber] = useState("");
    const [lrDateError, setLrDateError] = useState(false);
    const [lrNumberError, setLrNumberError] = useState(false);

    const [error, setError] = useState(true);

    const initialValues = {
        lrDate: lrDateValue,
        lrNumber: lrNumber
    }

    useEffect(() => {

        if (trip && trip.elrInfo && trip.elrInfo.lr_date) {
            setLrDateValue(trip.elrInfo.lr_date ? new Date(trip.elrInfo.lr_date * 1000) : "");
        } else if (trip && trip.elrLoadData && trip.elrLoadData.lr_date) {
            setLrDateValue(trip.elrLoadData.lr_date ? new Date(trip.elrLoadData.lr_date * 1000) : "");
        }

        if (trip && trip.elrInfo && trip.elrInfo.lr_number) {
            setLrNumber(trip.elrInfo.lr_number);
        } else if (trip && trip.elrLoadData && trip.elrLoadData.next_lr_number) {
            setLrNumber(trip.elrLoadData.next_lr_number)
        }

        if (trip && trip.elrInfo && trip.elrInfo.consignee && trip.elrInfo.consignee.id) {
            setConsigneeData(trip.elrInfo.consignee);
            setPopulatedConsignee('populated');
        }

        if (trip && trip.elrInfo && trip.elrInfo.consignor && trip.elrInfo.consignor.id) {
            setConsignorData(trip.elrInfo.consignor);
            setPopulatedConsignor('populated');
        }

    }, [trip.elrInfo]);

    useEffect(() => {

        if (trip && trip.singleConsignee && trip.singleConsignee.name) {
            setConsigneeData(trip.singleConsignee);
            setPopulatedConsignee('populated');
        }

        if (trip && trip.singleConsignor && trip.singleConsignor.name) {
            setConsignorData(trip.singleConsignor);
            setPopulatedConsignor('populated');
        }

    }, [trip.singleConsignee, trip.singleConsignor]);

    useEffect(() => {

        if (lrDateValue && lrNumber && consignorData && consignorData.name && consigneeData && consigneeData.name) {

            const regExp = /[a-zA-Z]/g;

            const values = {
                lr_date: regExp.test(lrDateValue) ? Math.round((lrDateValue.getTime()) / 1000) : lrDateValue,
                lr_number: lrNumber,
                consignee_id: consigneeData.id,
                consignor_id: consignorData.id
            }


            onDataPopulated(values);
            dispatchBiltyDataPopulated(true);
        } else {
            dispatchBiltyDataPopulated(false);
        }

        if (trip.biltyContinueClick) {
            onSubmit();
        }

    }, [lrDateValue, lrNumber, consignorData.name, consigneeData.name, trip.biltyContinueClick]);

    useEffect(() => {

        dispatchBiltyContinueClick(false);

    }, [lrDateValue, lrNumber, consignorData.name, consigneeData.name, open]);

    const onSubmit = (values) => {

        if (consignorData && !consignorData.name && trip.biltyContinueClick) {
            setPopulatedConsignor('notPopulated');
        }

        if (consigneeData && !consigneeData.name && trip.biltyContinueClick) {
            setPopulatedConsignee('notPopulated');
        }

        if (!lrDateValue) {
            setLrDateError(true);
        } else {
            setLrDateError(false);
        }

        if (!lrNumber) {
            setLrNumberError(true);
        } else {
            setLrNumberError(false);
        }

    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <div className={classes.divTitle}>LR Date*</div>
                            <DatePicker
                                name="lrDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                // label="Start Date"
                                placeholder="LR Date"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.textV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                onChange={(date) => {
                                    setLrDateValue(date)
                                    setLrDateError(false);
                                }}
                                error={lrDateError}
                            />
                            {lrDateError &&
                                <FormHelperText error={lrDateError} className={classes.divError}>Please select date</FormHelperText>
                            }
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.divTitle}>LR Number*</div>
                        <TextInputState
                            placeholder="LR Number"
                            name="lrNumber"
                            variant="outlined"
                            size="small"
                            className={classes.textV1}
                            onChange={(e) => {
                                setLrNumber(e.target.value)
                                setLrNumberError(false)
                            }}
                            error={lrNumberError}
                        />
                        {lrNumberError &&
                            <FormHelperText error={lrNumberError} className={classes.divError}>Please enter LR number</FormHelperText>
                        }
                    </div>
                )
            }
        ]
    }

    const handleDetails = (type) => {
        setSelectionDialog(true);
        setType(type);
    }

    const handleSelectionClose = () => {
        setSelectionDialog(false);
    }

    const handleDataSelect = (value) => {

        if (type == "consignor") {
            setConsignorData(value);
            setPopulatedConsignor('populated');
        } else if (type == "consignee") {
            setConsigneeData(value);
            setPopulatedConsignee('populated');
        }

    }

    return (
        <>
            <div className={classes.divContainerV2}>
                <Form
                    onSubmit={onSubmit}
                    keepDirtyOnReinitialize
                    initialValues={initialValues}
                    id="myForm"
                    render={({ handleSubmit, form, submitting, pristine, values }) => {
                        submit = handleSubmit
                        return (
                            <form onSubmit={handleSubmit} noValidate id="myForm">
                                <Grid container alignItems="flex-start">
                                    {getFormFields(values).map((item, idx) => item.visible ? (
                                        <Grid item xs={item.size} key={idx}>
                                            {item.field}
                                        </Grid>
                                    ) : null)}
                                </Grid>
                                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                            </form>
                        )
                    }}
                />

                <div className={classes.mtV2}>
                    <div className={classes.divTitleV1}>Consignor Details</div>
                    {consignorData && !consignorData.name &&
                        <>
                            <div className={populatedConsignor == "notPopulated" ? classes.divContainerError : classes.divContainer}>
                                <Button className={classes.addButton} onClick={() => handleDetails('consignor')}>
                                    <AddIcon className={classes.addIcon} />
                                    <span>
                                        Add Consignor
                                    </span>
                                </Button>
                            </div>
                            {populatedConsignor == "notPopulated" &&
                                <div className={classes.divError} >Please select Consignor</div>
                            }
                        </>
                    }
                    {consignorData && consignorData.name &&
                        <div className={classes.divContainerV1}>

                            <div className={classes.divV1}>
                                <div>
                                    <div className={classes.divTitleV2}>Consignor Name</div>
                                    <div>{consignorData.name}</div>
                                </div>
                                <div>
                                    <Button variant="contained" className={classes.changeButton} onClick={() => handleDetails('consignor')}>
                                        Change
                                    </Button>
                                </div>
                            </div>

                            <div className={classes.mtV1}>
                                <div className={classes.divTitleV2}>GST Number</div>
                                <div className={classes.divGst}>{consignorData && consignorData.gst_number ? consignorData.gst_number : "--"}</div>
                            </div>

                            <div className={classes.mtV3}>
                                <div className={classes.divTitleV2}>Company Address Line 1</div>
                                <div>{consignorData && consignorData.address_line_1 ? consignorData.address_line_1 : "--"}</div>
                            </div>

                            <div className={classes.mtV3}>
                                <div className={classes.divTitleV2}>Address Line 2</div>
                                <div>{consignorData && consignorData.address_line_2 ? consignorData.address_line_2 : "--"}</div>
                            </div>

                            <div className={classes.divV2}>
                                <div>
                                    <div className={classes.divTitleV2}>State</div>
                                    <div>{consignorData && consignorData.state ? consignorData.state : "--"}</div>
                                </div>
                                <div className={classes.divEnd}>
                                    <div className={classes.divTitleV2}>Pincode</div>
                                    <div>{consignorData && consignorData.pincode ? consignorData.pincode : "--"}</div>
                                </div>
                            </div>

                            <div className={classes.mtV3}>
                                <div className={classes.divTitleV2}>Mobile Number</div>
                                <div>{consignorData && consignorData.contact_number ? consignorData.contact_number.replace(/(\d{5})(\d{5})/, "$1-$2") : "--"}</div>
                            </div>

                        </div>
                    }
                </div>

                <div className={classes.mtV1}>
                    <div className={classes.divTitleV1}>Consignee Details</div>
                    {consigneeData && !consigneeData.name &&
                        <>
                            <div className={populatedConsignee == "notPopulated" ? classes.divContainerError : classes.divContainer}>
                                <Button className={classes.addButton} onClick={() => handleDetails('consignee')}>
                                    <AddIcon className={classes.addIcon} />
                                    <span>
                                        Add Consignee
                                    </span>
                                </Button>
                            </div>
                            {populatedConsignee == "notPopulated" &&
                                <div className={classes.divError} >Please select Consignee</div>
                            }
                        </>
                    }
                    {consigneeData && consigneeData.name &&
                        <div className={classes.divContainerV1}>

                            <div className={classes.divV1}>
                                <div>
                                    <div className={classes.divTitleV2}>Consignee Name</div>
                                    <div>{consigneeData.name}</div>
                                </div>
                                <div>
                                    <Button variant="contained" className={classes.changeButton} onClick={() => handleDetails('consignee')}>
                                        Change
                                    </Button>
                                </div>
                            </div>

                            <div className={classes.mtV1}>
                                <div className={classes.divTitleV2}>GST Number</div>
                                <div className={classes.divGst}>{consigneeData && consigneeData.gst_number ? consigneeData.gst_number : "--"}</div>
                            </div>

                            <div className={classes.mtV3}>
                                <div className={classes.divTitleV2}>Company Address Line 1</div>
                                <div>{consigneeData && consigneeData.address_line_1 ? consigneeData.address_line_1 : "--"}</div>
                            </div>

                            <div className={classes.mtV3}>
                                <div className={classes.divTitleV2}>Address Line 2</div>
                                <div>{consigneeData && consigneeData.address_line_2 ? consigneeData.address_line_2 : "--"}</div>
                            </div>

                            <div className={classes.divV2}>
                                <div>
                                    <div className={classes.divTitleV2}>State</div>
                                    <div>{consigneeData && consigneeData.state ? consigneeData.state : "--"}</div>
                                </div>
                                <div className={classes.divEnd}>
                                    <div className={classes.divTitleV2}>Pincode</div>
                                    <div>{consigneeData && consigneeData.pincode ? consigneeData.pincode : "--"}</div>
                                </div>
                            </div>

                            <div className={classes.mtV3}>
                                <div className={classes.divTitleV2}>Mobile Number</div>
                                <div>{consigneeData && consigneeData.contact_number ? consigneeData.contact_number.replace(/(\d{5})(\d{5})/, "$1-$2") : "--"}</div>
                            </div>

                        </div>
                    }
                </div>
            </div>
            {selectionDialog && <ConsigneeConsignorSelect open={selectionDialog} type={type} onClose={handleSelectionClose} onSelect={handleDataSelect} />}
        </>
    )

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchBiltyDataPopulated: (value) => {
        dispatch(biltyDataPopulated(value))
    },
    dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value))
});
export default connect(mapStateToProps, mapDispatchToProps)(BiltyConsignorConsignee);